module.exports = __webpack_public_path__ + "img/taoyuan-3.5f388f03.jpg";